// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b66626b","565":"c0338058","830":"35b59ee1","861":"2636f38e"}[chunkId] + ".chunk.js";
};